import { useState } from 'react';

const checklistItems = [
  'Новички долго входят в работу — 3+ месяца до первых результатов',
  'Часто увольняются в первые 3-6 месяцев после трудоустройства',
  'Боятся задавать вопросы и совершают ошибки из-за незнания',
  'Нет чек-листов для адаптации — каждый руководитель придумывает своё',
  'Нет наставников — некому обучать и поддерживать новичков',
  'Нет единой программы адаптации сотрудников — хаос в онбординге',
  'Обучение происходит случайно — «по ходу дела разберётся»',
  'Руководители не знают, что делать с новым сотрудником в первый день',
  'Новые сотрудники чувствуют себя чужими в коллективе',
  'Нет системы оценки эффективности адаптации — непонятно, работает ли',
  'Нет welcome-пакета и базовых материалов для знакомства с компанией',
  'Испытательный срок — формальность без конкретных целей и задач',
  'Новички повторяют одни и те же ошибки из-за отсутствия стандартов',
  'Руководители жалуются, что «новички не те пошли» вместо анализа системы',
  'Сложно внедрять изменения — новые сотрудники не понимают ценности компании',
];

export default function ChecklistProblems() {
  const [checked, setChecked] = useState<Record<number, boolean>>({});

  const toggleCheck = (i: number) => {
    setChecked(prev => ({ ...prev, [i]: !prev[i] }));
  };

  const checkedCount = Object.values(checked).filter(Boolean).length;

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Чек-лист: есть ли проблемы в вашей адаптации?
        </h2>
        <p className="text-lg text-gray-600 text-center mb-6 max-w-3xl mx-auto leading-relaxed">
          Отметьте утверждения, которые верны для вашей компании. Честная самодиагностика — первый шаг к построению эффективной системы адаптации персонала.
        </p>

        <div className="bg-teal-50 border border-teal-200 rounded-xl p-6 mb-8 text-center">
          <span className="text-3xl font-extrabold text-teal-600">{checkedCount}</span>
          <span className="text-lg text-teal-700"> / {checklistItems.length} признаков проблем с адаптацией</span>
          {checkedCount >= 5 && (
            <p className="text-teal-700 mt-2 font-semibold">Пора внедрять системную программу адаптации персонала!</p>
          )}
        </div>

        <div className="space-y-3">
          {checklistItems.map((item, i) => (
            <button
              key={i}
              onClick={() => toggleCheck(i)}
              className={`w-full flex items-start gap-4 p-4 rounded-xl text-left transition-all cursor-pointer border ${
                checked[i]
                  ? 'bg-teal-600 text-white border-teal-600'
                  : 'bg-gray-50 text-gray-700 border-gray-200 hover:border-teal-300'
              }`}
            >
              <div className={`w-6 h-6 rounded-md flex items-center justify-center flex-shrink-0 mt-0.5 transition-colors ${
                checked[i] ? 'bg-white text-teal-600' : 'border-2 border-gray-300'
              }`}>
                {checked[i] && <i className="ri-check-line font-bold"></i>}
              </div>
              <span className="text-sm md:text-base leading-relaxed">{item}</span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}